import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=05bca060&"
import script from "./IconLink.vue?vue&type=script&lang=js&"
export * from "./IconLink.vue?vue&type=script&lang=js&"
import style0 from "./IconLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports